/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "It is with great pride that we announce that ", React.createElement(_components.a, {
    href: "../../people/brendan-case/"
  }, "Bren Case"), " has successfully defended their thesis entitled “", React.createElement(_components.a, {
    href: "https://scholarworks.uvm.edu/graddis/1778/"
  }, "Bayesian experimental design for control and surveillance in epidemiology"), "” and has therefore been awarded the Ph.D. title."), "\n", React.createElement(_components.p, null, "Dr. Case is now continuing their research as a Post-doctoral Fellow in the Epidemiology and Biostatistics department at the University of Georgia, where their unparalleled talent will no doubt continue to make waves.\nCongratulations!"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
